import { DynamicFormControlLayout, serializable } from '@ng-dynamic-forms/core';
import { CustomDynamicSelectModel, CustomDynamicSelectModelConfig } from '../shared-models/custom-dynamic-select.model';

export const TYPE_SELECT_EDIT = 'SELECT-EDIT';

export interface SelectEditModelConfig<T> extends CustomDynamicSelectModelConfig<T> {
  eventName?: string;
  isEditableFn?: (val: T) => boolean;
}

export class SelectEditModel<T> extends CustomDynamicSelectModel<T> {
  @serializable() readonly type: string = TYPE_SELECT_EDIT;
  @serializable() eventName: string | null;
  isEditableFn: (val: T) => boolean;

  constructor(config: SelectEditModelConfig<T>, layout?: DynamicFormControlLayout) {
    super(config, layout);
    this.eventName = config.eventName || null;
    this.isEditableFn = config.isEditableFn || (() => true);

    // tell ng-dynamic-forms not to display additional label and errorMessages
    this.additional = {
      ...this.additional,
      isFormFieldControl: true
    };
  }
}

export interface EditEventDetail<T> {
  data: T;
  resolve: (editedData: T) => void;
}
